import { Getters } from "vuex";
import { PromiseGetters, PromiseState } from "./types";

export const getters: Getters<PromiseState, PromiseGetters> = {};
